import React from 'react';
import { connect } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { withRouter } from 'react-router-dom';
import { Button, Spinner, Modal, Alert, Card } from 'react-bootstrap';

//ACTIONS
import { pesquisa as pesquisatraducoes } from '../../../actions/traducoes/traducoes';
import { pesquisa as pesquisatratamentos } from '../../../actions/credenciamento/tratamento';
import { novo as getcredencial, pesquisa as pesquisacadastro } from '../../../actions/credenciamento/credencial';
import { pesquisa as pesquisacargos } from '../../../actions/credenciamento/cargo';
import { pesquisa as pesquisaquestionario } from '../../../actions/questionario/questionarios';
import { paises, tipologradouro, pesquisacep, cidade as pesquisacidade, estados as pesquisaestados } from '../../../actions/endereco/endereco';
import { pesquisa as pesquisaformcampos } from '../../../actions/forms/validacao';
import { pesquisa as pesquisatermos } from '../../../actions/termos/modelos';

//COMPONENTS
import Autorizacoes from '../../../components/forms/credenciamento/Autorizacoes';
import PerguntasRespostas from '../../../components/forms/credenciamento/PerguntasRespostas';
import DadosComerciais from '../../../components/forms/credenciamento/DadosComerciais';
import DadosDeAcesso from '../../../components/forms/credenciamento/DadosDeAcesso';
import DadosDeEndereco from '../../../components/forms/credenciamento/DadosDeEndereco';
import DadosEmpresa from '../../../components/forms/credenciamento/DadosEmpresa';
import DadosPessoais from '../../../components/forms/credenciamento/DadosPessoais';
import TermosForm from '../../../components/forms/termos/TermosForm';

//TOOLS
import { getCamposFormatadosValidacao, LogErrorLabels } from '../../../components/forms/utils/toolsforms';
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';
import { getCategoriaUsuario, getUserLoginCred, removeUserLoginCred, setCredencialPronta, removePedidoConfirmado, setEmailConfirmacaoCred } from '../../../utils/eventosessioncred';
import { validacao as validacaoform, getCamposCssObrigatorios } from '../../../components/forms/utils/toolsvalidacao';

//Helpers
import { TelaModalLivre } from '../../../helpers/TelaModal';

class FormCredenciamento extends React.Component {

    state = {
        formCamposValidacao: false,
        formCamposVlaidacaoCarregado: false,
        showmodalerrors: false,
        styles: {},
        cadastro: {},
        showTermos: false,
        termosaceitos: false,
        termos: []
    }
    
    async componentDidMount(){

        removePedidoConfirmado();
        setEmailConfirmacaoCred(0);
        
        const dados_basico = {
            idevento: 1, 
            idpromotora: this.props.dadosevento.idpromotora
        }

        const dados_basico_evento = {
            idevento: this.props.dadosevento.idevento, 
            idpromotora: this.props.dadosevento.idpromotora
        }

        await this.props.pesquisatraducoes({
                ...dados_basico_evento,
                wherein: JSON.stringify({ 
                    campo: 'identificador', 
                    valores: ['passo1','end','novopasso1']                
                })
            }
        );

        await this.props.pesquisatratamentos(dados_basico);
        await this.props.pesquisacargos({...dados_basico_evento, mostra: 'S'});
        await this.props.paises();
        await this.props.tipologradouro();        
        
        let cadastro = getUserLoginCred();

        let response = {};
        let campos = {};
        let css = {};
        if(!this.props.somenteperguntas){
            response = await this.props.pesquisaformcampos({...dados_basico_evento, categoria: this.props.dadosevento.categoria, linguagem: this.props.dadosevento.lingua});
            campos = getCamposFormatadosValidacao(response);
            css = getCamposCssObrigatorios(campos);

            if(cadastro && cadastro.fisica && cadastro.fisica.idfisica > 0){
                if(cadastro.fisica.juridica.cep !== ''){
                    await this.props.pesquisacep(cadastro.fisica.juridica.cep);
                }
            }else{
                //NOVO CADASTRO PRECISA ACEITAR OS TERMOS
                this.setState({
                    showTermos: false
                });
            }
        }
                
        //const questionario = await this.handlePesquisaQuestionario({passo: cadastro && cadastro.fisica && parseInt(cadastro.fisica.juridica.idpais)!==214?[1,3,6]:[1,3,2]});
        const questionario = await this.handlePesquisaQuestionario({passo: cadastro && cadastro.fisica && parseInt(cadastro.fisica.juridica.idpais)!==214?[1,3,2,6]:[1,3,2,6]});
        this.setState({
            formCamposValidacao: campos,
            styles: css,
            cadastro: this.handleDadosCadastraisPesquisa(cadastro, questionario)
        });
        
        if(!cadastro.fisica || (cadastro && cadastro.fisica && cadastro.fisica.idfisica > 0 && !cadastro.fisica.credencial.termos.idfaq)){
            //pesquisa termo de credenciamento
            const termos = await this.props.pesquisatermos({...dados_basico_evento, idtermostipos: 4});
            if(termos&&termos[0]&&termos[0].idfaq){
                this.setState({termos: termos});
                this.handleModalTermos();
            }
        }
    }

    handlePesquisaQuestionario = async (filtros = {}) => {
        const dados_basico_evento = {
            idevento: this.props.dadosevento.idevento, 
            idpromotora: this.props.dadosevento.idpromotora,
            ...filtros
        }
        const questionario = await this.props.pesquisaquestionario({...dados_basico_evento, categoria: this.props.dadosevento.categoria});        
        return questionario;
    }
        
    onSubmit  = async (form) => {
        
        const dados_basico_evento = {
            idcategoriausuario: getCategoriaUsuario(),
            idevento: this.props.dadosevento.idevento, 
            idpromotora: this.props.dadosevento.idpromotora,
            tipocred: this.props.dadosevento.categoria,
            idioma: this.props.dadosevento.lingua.toLowerCase(),
            termosaceitos: this.state.termosaceitos,
            ...(this.state.cadastro && this.state.cadastro.fisica && this.state.cadastro.fisica.idfisica?{idfisica: this.state.cadastro.idfisica}:{})
        }

        const dados = {
            ...form,
            ...dados_basico_evento
        }

        setCredencialPronta(await this.props.getcredencial(dados));
        this.props.history.push('credencial');        
    }

    handleModalErrors = () => {
        this.setState({
            showmodalerrors: this.state.showmodalerrors?false:true
        });
    }

    handleErrorSubmit = (props) => {
        if(props.submitFailed === true){
            const errors_labels = LogErrorLabels(props);                        
            return (
                <Modal show={this.state.showmodalerrors} onHide={this.handleModalErrors}>
                    <Modal.Header closeButton>
                    <Modal.Title>{trad(this.props.trads,'INFOVALIDCAMPHED',this.props.dadosevento.lingua)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>                        
                        {errors_labels.map((itens, indice) => {
                            return (                                
                                <Alert variant="warning" key={indice}>{itens}</Alert>
                            )
                        })}
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleModalErrors}>
                        OK
                    </Button>                    
                    </Modal.Footer>
                </Modal>                
            )
        }else{
            <Alert variant="success">Dados Enviados</Alert>
        }
    }

    handleSubmitLog = () => {
        setTimeout(() => {
            this.handleModalErrors();
        },500);
    }

    handleValidate = (values) => {

        let campos_iginore = {};//Por conta de compatibilidade de credenciamentos app antiga
        if(this.state.cadastro && this.state.cadastro.idfisica > 0){
            campos_iginore = {
                senha: 'senha',
                confsenha: 'confsenha',
                confemail: 'confemail'
            }
        }
        
        return validacaoform(
            values,
            this.state.formCamposValidacao,
            trad,this.props.trads,
            this.props.dadosevento.lingua,
            {
                PerguntaseRespostas: 'PerguntaseRespostas',
                analyticsFormErrors: 'analyticsFormErrors',
                soube: 'soube',
                origemcaravana: 'origemcaravana',
                outroscargos: 'outroscargos',
                cidade: 'cidade',
                tipolog: 'tipolog',
                campoX: 'campoX',
                text: 'text',
                analyticsFormFieldErrors: 'analyticsFormFieldErrors',
                ...campos_iginore
            }
        );
    }

    handleDadosCadastraisPesquisa = (cadastro = {}, questionario = []) => {
        if(!Object.keys(cadastro).length){            
            return this.handlePerguntaPesquisaNovoCadastro(questionario);
        }
        
        let respostas = {};
        let perguntas_novas_formatadas = {};
        if(cadastro.fisica.credencial.questionario.length){
            respostas = this.handlePerguntaPesquisa(cadastro.fisica.credencial.questionario);
            //Perguntas Novas Para Credenciaidos
            
            const perguntas_novas = questionario.filter(itens => {
                return cadastro.fisica.credencial.questionario.find(element => element.resposta.idpergunta===itens.idpergunta)===undefined?true:false;
            });
            
            if(perguntas_novas.length){
                perguntas_novas_formatadas = this.handlePerguntaPesquisaNovoCadastro(perguntas_novas);
            }            
        }
        console.log(cadastro.fisica.credencial.cargocredencial);
        return {
            ...cadastro.fisica,
            ...cadastro.fisica.credencial.cargocredencial,
            ...cadastro.fisica.juridica,
            ...cadastro.fisica.juridica.cidade_pesquisa?cadastro.fisica.juridica.cidade_pesquisa:{},
            ...cadastro.fisica.juridica.cidade_pesquisa?cadastro.fisica.juridica.cidade_pesquisa.estado:{},
            ...respostas,
            ...perguntas_novas_formatadas
        };
    }

    handlePerguntaPesquisa = (respostas = []) => {
        let resposta_formatada = {};
        respostas.map(itens => {
            
            const prefix_campo = itens.resposta.outrosespecificar==='S'?'o':'p';
            if(!resposta_formatada[`${prefix_campo}_${itens.resposta.idpergunta}`]){
                resposta_formatada[`${prefix_campo}_${itens.resposta.idpergunta}`] = [];
            }

            if(itens.resposta.pergunta.variasrespostas === 0){
                resposta_formatada[`${prefix_campo}_${itens.resposta.idpergunta}`] = `${itens.idconteudopergunta}`;
            }else{
                resposta_formatada[`${prefix_campo}_${itens.resposta.idpergunta}`].push(`${itens.idconteudopergunta}`);
            }

            
            if(itens.outrosespecificar!==''){
                resposta_formatada[`outrosespecificar_${itens.resposta.idpergunta}_${itens.idconteudopergunta}`] = `${itens.outrosespecificar}`;
            }
            
            return null;
        });

        return resposta_formatada;
    }

    handlePerguntaPesquisaNovoCadastro = (questionario = []) => {
        let dados = {}
        questionario.map(item => {
            return item.resposta.map(resp => {
                const prefix_campo = resp.outrosespecificar==='S'?'o':'p';
                if(resp.checked === 'S'){
                    dados = {
                        ...dados,
                        [`${prefix_campo}_${resp.idpergunta}`]: `${resp.idconteudopergunta}`
                    }
                }
                return {                        
                    [`${prefix_campo}_${resp.idpergunta}`]: `${resp.idconteudopergunta}`
                }                
            });
        });
        return dados;
    }

    handleCloseTermos = (form) => {        
        this.setState({
            showTermos: this.state.showTermos?false:true,
            termosaceitos: form
        });
    }

    handleModalTermos = () => {        
        this.setState({
            showTermos: true            
        });
    }

    handleBtoSair = () => {
        removeUserLoginCred();
        this.props.handleNovoCad();
    }
                
    render(){

        const lingua = this.props.dadosevento.lingua;        
        const cadastro = this.state.cadastro;       
        
        return (            
            <Card.Body>
                <TelaModalLivre titulo="Leia os Termos" show={this.state.showTermos} handleCloseModal={this.handleCloseTermos} btoFechar={false}>
                    <TermosForm  handleCloseTermos={this.handleCloseTermos} termos={this.state.termos} />
                </TelaModalLivre>
                {this.state.formCamposValidacao&&this.state.formCamposValidacao.length!==false?            
                <FinalForm 
                    name='formCred'                
                    onSubmit={this.onSubmit}
                    initialValues={{
                        ...cadastro,
                        ...this.props.dadosevento.lingua==='pt'?{idpais: 214}:{}
                    }}
                    mutators={{                    
                        ...arrayMutators,
                        setValue: ([field, value], state, { changeValue }) => {
                            changeValue(state, field, () => value)
                        }                    
                    }}
                    validate={this.handleValidate}
                    render={({handleSubmit, form, submitting, errors, submitFailed}) => (
                        <form onSubmit={handleSubmit} method="post">
                            <DadosDeAcesso 
                            handlePesquisaQuestionario={this.handlePesquisaQuestionario}
                            {...this.props} form={form} lingua={lingua} styles={this.state.styles} />
                            <DadosPessoais {...this.props} form={form} lingua={lingua} styles={this.state.styles} />
                            <DadosEmpresa {...this.props} form={form} lingua={lingua} styles={this.state.styles} />
                            <DadosDeEndereco 
                            handlePesquisaQuestionario={this.handlePesquisaQuestionario}
                            {...this.props} 
                            cep={cadastro.fisica?cadastro.fisica.juridica.cep:0}
                            form={form} 
                            lingua={lingua} 
                            styles={this.state.styles} />
                            
                            <PerguntasRespostas {...this.props} form={form} lingua={lingua} styles={this.state.styles} />
                            <Autorizacoes className="mt-2" {...this.props} form={form} lingua={lingua} styles={this.state.styles} />
                            {this.handleErrorSubmit({errors: errors, submitFailed: submitFailed})}
                            <Button          
                                id="btosubmit"               
                                variant="primary" 
                                size="lg" 
                                block 
                                type="submit"       
                                onClick={this.handleSubmitLog}
                                disabled={submitting || this.props.pendingTasks}
                                >                            
                                {submitting?<Spinner animation="border" />:trad(this.props.trads,'AVANCAR',lingua)}
                            </Button>
                            <Button
                                variant="secondary" 
                                size="lg" 
                                block 
                                type="button"
                                onClick={this.handleBtoSair}                            
                                >
                                {trad(this.props.trads,'SAIR',lingua)}
                            </Button>
                        </form>
                    )}
                />  
                :
                null
                }
            </Card.Body>            
        );
    }
}

const mapStateToProps = (state) => {
    return {
        pendingTasks: state.pendingTasks,
        trads: state.reducerTraducoes,
        tratamentos: state.pesquisaTratamentoReducer,
        paisespesquisa: state.pesquisaPaisesReducer,
        tipologradouros: state.tipologradourosReducers,
        cepdados: state.cepReducers,
        dadoscargos: state.pesquisaCargosReducer,
        pergrespevento: state.pergrespReducer,
        formsPesquisaCampos: state.formsPesquisaCamposReducer,
        getCredencial: state.getCredencialReducer,
        pesquisaCadastroReducer: state.pesquisaCadastroReducer
    }
}

export default connect(mapStateToProps,{
    pesquisatraducoes,
    pesquisatratamentos,
    paises,
    tipologradouro,
    pesquisacep,
    pesquisacargos,
    pesquisaquestionario,
    pesquisaformcampos,
    getcredencial,
    pesquisacadastro,
    pesquisaestados,
    pesquisacidade,
    pesquisatermos
})(withRouter(FormCredenciamento));